import React , { useEffect, useRef } from 'react';
import { FiPhoneCall, FiPhoneOff, FiVoicemail } from 'react-icons/fi';
import { useCallStore } from "../../../router/zustand/callStore";
import ringtone from "../../../assets/incoming_calls_ringtones/ringtone1.mp3";

function RingingScreen({ onAccept , onReject}) {
  const callerNumber = useCallStore((state) => state.callerNumber);
  const session = useCallStore((state) => state.session);
  const callState = useCallStore((state) => state.callState);
  const sipLeadData = useCallStore((state) => state.sipLeadData);
  const sipCampaignId = useCallStore((state) => state.sipCampaignId);
  const sipHeaders = useCallStore((state) => state.sipHeaders);
  const incomingReceivedAt = useCallStore((state) => state.incomingReceivedAt);
  const isAnswering = useCallStore(state => state.isAnswering);
  const audioRef = useRef(null);

  if (session && session.request) {
    const headers = session.request.headers;
    console.log("All Headers:", headers);
  }

  useEffect(() => {
    if (callState !== "incoming") return;

    if (audioRef.current) {
      audioRef.current.loop = true;
      audioRef.current.play().catch((err) => {
        console.log("Autoplay blocked:", err);
      });
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [callState]);

  const getHeader = (name) => {
    const lower = String(name || "").toLowerCase();
    const fromStore = sipHeaders?.[lower];
    if (fromStore) return String(fromStore);
    try {
      return session?.request?.getHeader?.(name) || null;
    } catch {
      return null;
    }
  };

  const extractSipUser = (headerValue) => {
    if (!headerValue) return null;
    const match = String(headerValue).match(/sip:([^@;>]+)@/i);
    return match?.[1] || null;
  };

  const toUser = extractSipUser(getHeader("To"));
  const fromUser = extractSipUser(getHeader("From")) || callerNumber || null;
  const callId = getHeader("Call-ID");
  const userAgent = getHeader("User-Agent");
  const via = getHeader("Via");
  const cseq = getHeader("CSeq");
  const sessionExpires = getHeader("Session-Expires");
  const maxForwards = getHeader("Max-Forwards");

  const callDetailsFields = [
    ["Caller Number", fromUser || "-", ""],
    ["Extension", toUser || "-", ""],
    ["Call ID", callId || "-", ""],
    ["Transport", via && String(via).toUpperCase().includes("/WS") ? "WebSocket (WS)" : "-", ""],
    ["PBX/User-Agent", userAgent || "-", ""],
    ["CSeq", cseq || "-", ""],
    ["Session Expires", sessionExpires ? `${sessionExpires}s` : "-", ""],
    ["Max Forwards", maxForwards || "-", ""],
    ["Ringing Since", incomingReceivedAt ? new Date(incomingReceivedAt).toLocaleString("en-IN") : "-", ""],
  ].filter(([, value]) => value && value !== "-");

  const displayName = (() => {
    const name = `${sipLeadData?.first_name || ""} ${sipLeadData?.last_name || ""}`.trim();
    if (name) return name;
    if (sipLeadData?.company) return String(sipLeadData.company);
    if (fromUser) return String(fromUser);
    return "Unknown";
  })();

  const getAvatarText = (value) => {
    const parts = String(value || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  };

  const ringLabel = (() => {
    const segments = ["Incoming Call"];
    if (sipCampaignId) segments.push(`Campaign ${sipCampaignId}`);
    if (sipLeadData?.company && displayName !== sipLeadData.company) {
      segments.push(String(sipLeadData.company));
    }
    return segments.join(" - ");
  })();

  return (
    <div className="screen active">
       <audio ref={audioRef} src={ringtone} />
      <div className="ringing-layout">
        <div className="ring-main" style= {{marginRight: '5px', paddingTop: "20px", paddingBottom: "20px", marginBottom: '5px'}}>
          {(callState === "incoming") ?
          (<>
          <div className="ring-bg-strip" />
          <div className="ring-wave" />
          <div className="ring-wave" />
          <div className="ring-wave" />
          <div className="ring-avatar">{getAvatarText(displayName)}</div>
          <div className="ring-name">{displayName}</div>
          <div className="ring-num">{callerNumber}</div>
          <div className="ring-label">{ringLabel}</div>
          {(!isAnswering ? (
            <div className="ring-actions">
              <div className="ring-action-col">
                <button type="button" className="ring-btn ring-vm"><FiVoicemail /></button>
                <div className="ring-btn-label muted-label">Voicemail</div>
              </div>
              <div className="ring-action-col">
                <button type="button" className="ring-btn ring-accept"
                onClick={() => {
                  audioRef.current?.pause();
                  onAccept();
                }}
              ><FiPhoneCall /></button>
                <div className="ring-btn-label accept-label">Accept</div>
              </div>
              <div className="ring-action-col">
                <button type="button" className="ring-btn ring-decline"             
                  onClick={() => {
                  audioRef.current?.pause();
                  onReject();
                }}>
                <FiPhoneOff /></button>
                <div className="ring-btn-label decline-label">Decline</div>
              </div>
            </div>
          ) : (
            <div className="answering-state">
              <div className="answering-loader"></div>
              <div className="answering-text">Answering...</div>
            </div>
          ))}

          </>)
          : (<>
          <div className="ring-name">
            No Active Call
          </div>
          </>)}
          
        </div>

        <div className="ring-sidebar">
          <div className="crm-card" style= {{paddingTop: "22px", paddingBottom: "22px"}}>
            <div className="crm-section-title">Call Details</div>
            <div className="crm-profile-head">
              <div className="cti-avatar crm-avatar">A1</div>
              <div>
                <div className="crm-name">
                  {sipLeadData?.first_name || sipLeadData?.last_name
                    ? `${sipLeadData?.first_name || ""} ${sipLeadData?.last_name || ""}`.trim()
                    : "Unknown"}
                </div>
                <div className="crm-id">Caller: {callerNumber || "-"}</div>
              </div>
            </div>
            {callDetailsFields.length > 0 ? (
              callDetailsFields.map(([key, value, color]) => (
              <div className="crm-field" key={key}>
                <span className="crm-key">{key}</span>
                <span className={`crm-val ${color}`}>{value}</span>
              </div>
              ))
            ) : (
              <div className="crm-field">
                <span className="crm-key">Details</span>
                <span className="crm-val">-</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="crm-card">
        <div className="crm-section-title">Campaign Routing</div>
          <div className="campaign-route-card">
            <div className="campaign-route-title">Mortgage Refinance Q1</div>
            <div className="campaign-route-sub">Priority Queue - Predictive Dial - 2nd in queue</div>
          </div>
          <div className="crm-field"><span className="crm-key">DID Number</span><span className="crm-val blue">+91 22 4000 8899</span></div>
          <div className="crm-field"><span className="crm-key">Wait Time</span><span className="crm-val amber">00:38</span></div>
        </div>

      <div className="crm-card">
        <div className="crm-section-title">Previous Outcome</div>
        <div className="announce-card amber-bg no-margin">
          <div className="announce-tag amber-text">Callback Requested</div>
          <div className="announce-copy">"Interested but wanted to review documents. Call back after 3 days."</div>
          <div className="micro-meta">3 days ago - Agent: Nisha P.</div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(RingingScreen);
